import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const updateEmployeeRequirementCreatedWebhook = (
  axios: IAxiosInstance
) => {
  return async ({
    url,
    testMode,
  }: ISchema["#/definitions/IUpdateEmployeeRequirementCreatedWebhookBody"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IUpdateEmployeeRequirementCreatedWebhookResponse"]
    >(`/api/updateEmployeeRequirementCreatedWebhook`, {
      url,
      testMode,
    });

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
